import { showModal } from './modalState';

/**
 * Modal utility class for Vue 3
 * Uses a global modal container instead of creating separate Vue apps
 */
export default class Modal {
    /**
     * Show an alert modal
     */
    static async alert(title, message, callback) {
        const { default: AlertModal } = await import('../components/modals/Alert.vue');

        try {
            await showModal(AlertModal, { title, message });
            if (callback) callback();
        } catch {
            if (callback) callback();
        }
    }

    /**
     * Show a confirm modal
     *
     * @param {{ confirmText?: string, confirmType?: string }} options  a button that
     *        names the act ("Delete permanently") and its colour (is-danger)
     */
    static async confirm(title, message, { confirmText, confirmType } = {}) {
        const { default: ConfirmModal } = await import('../components/modals/Confirm.vue');
        return showModal(ConfirmModal, { title, message, confirmText, confirmType });
    }

    /**
     * Show a prompt modal with text input
     * Returns the entered value, or rejects if cancelled
     */
    static async prompt(
        title,
        message,
        { placeholder, defaultValue, confirmText, allowEmpty, type, min, max, step, maxlength, rows } = {}
    ) {
        const { default: PromptModal } = await import('../components/modals/Prompt.vue');
        return showModal(PromptModal, {
            title,
            message,
            placeholder,
            defaultValue,
            confirmText,
            allowEmpty,
            type,
            min,
            max,
            step,
            maxlength,
            rows
        });
    }

    /**
     * Show a custom modal component
     */
    static show(viewComponent, propsData = {}) {
        return showModal(viewComponent, propsData, { isFormModal: true });
    }
}
